export default __webpack_public_path__ + "static/media/2021-detroit-gp-wallpaper.9876195f.jpg";